<template>
  <div>
    <ocs v-if="type == 'ocs'" />
    <ems v-if="type == 'ems'" />
    <emsAviation v-if="type == 'emsAviation'" />
  </div>
</template>
<script>
import ocs from "@/components/Printedsheet/expressSinglePrint/ocs";
import ems from "@/components/Printedsheet/expressSinglePrint/ems";
import emsAviation from "@/components/Printedsheet/expressSinglePrint/emsAviation";

export default {
  components: {
    ocs,
    ems,
    emsAviation,
  },
  data() {
    return {
      type: this.$route.query.type,
    };
  },
  methods: {
    // 文字转化html
    textToHtml(v) {
      if (!v) return v;
      let arr = v.split("\n");
      let str = "";
      arr.forEach((element) => {
        str += `${element}<br />`;
      });
      return str;
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped></style>
